import { useMutation, useQueryClient } from "@tanstack/react-query";
import { clientServices } from "./client.services";
import { CLIENT_KEYS } from "./client.keys";

export const useImportClients = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clientServices.importFromCsv,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CLIENT_KEYS.GET_CLIENTS({}),
      });
    },
  });
};

export const useCreateClient = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clientServices.createClient,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CLIENT_KEYS.GET_CLIENTS({}),
      });
    },
  });
};

export const useUpdateClient = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clientServices.updateClient,
    onSuccess: (_, variables) => {
      // Invalidate all client-related queries
      queryClient.invalidateQueries({
        queryKey: [CLIENT_KEYS.CLIENTS],
      });
      queryClient.invalidateQueries({
        queryKey: [CLIENT_KEYS.CLIENT, variables.id],
      });
      // Also invalidate any queries that might depend on client data
      queryClient.invalidateQueries({
        predicate: (query) => {
          return query.queryKey.some((key) =>
            typeof key === 'string' && key.includes('client')
          );
        },
      });
    },
  });
};

export const useDeleteClient = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clientServices.deleteClient,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CLIENT_KEYS.GET_CLIENTS({}),
      });
    },
  });
};

export const useCreateServiceRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clientServices.createServiceRequest,
    onSuccess: () => {
      // Invalidate booking queries to show the new service request
      queryClient.invalidateQueries({
        queryKey: ["bookings"],
      });
    },
  });
};
